import axios from '@/http/axios/index.js'


export default {
    getList(payload) {
        return axios.get('warehouse/ranges/list', { params: payload })
    },
    addRange(payload) {
        return axios.post('warehouse/ranges/store', payload)
    },
    updateRange(payload) {
        return axios.post('warehouse/ranges/update', payload)
    },
    deleteRange(payload) {
        return axios.delete('warehouse/ranges/delete', { params: payload })
    }
}